import { tmxApiCall } from './index'

// Utilities
import Logger from '../utility/loggerUtil'

export default {
  /**
   * Retrieves balance history pertaining to specific customer.
   * @returns {Promise<{[{id: Number, date: String, amount: Number, balance: Number, type: String}]}>} a collection of Balance History.
   */
  async getBalanceHistory () {
    Logger.info('Started get Balance History query.')
    return tmxApiCall('get', '/referralBalanceHistory')
  },

  /**
   * Retrieves referral stats pertaining to specific customer.
   * @returns {Promise<{peopleSignedUp: Number, referCodesScanned: Number}>} Customer Referral Stats.
   */
  async getReferralStats () {
    Logger.info('Started referral stats request')
    return tmxApiCall('get', '/referralStats')
  },

  /**
   * Gets their current status of the secure acceptance session. Once customer submits card info, postback to API generates a status.
   * @param {String} transactionUuid - The UUID for the card transaction to check.
   * @returns {Promise<Object>} The secure acceptance card transaction status.
   */
  async getSecureAcceptStatus (transactionUuid) {
    Logger.info('Getting secure accept card transaction status')
    return tmxApiCall('get', '/cardSecureAcceptance', {
      params: {
        transactionUuid
      }
    })
  },

  /**
   * Starts a balance disbursement to a card.
   * @param {String} cardNumber - The last 4 digits of the card to disbursed to.
   * @param {String} cardToken - The token for the card to disburse to.
   * @returns {Promise<{messageKey: String}>} Message key is an id to check for a disbursement status.
   */
  async initiateDisbursement (cardNumber, cardToken) {
    Logger.info('Initiating disbursement to card')
    return tmxApiCall('post', '/cashOut', {
      cardNumber,
      cardToken
    })
  },

  /**
   * Checks the status of a disbursement to a card.
   * @param {String} messageKey - The identifier to check a disbursements status.
   * @returns {Promise<{status: String, confirmationNumber: String, error: String}>} Returns back a status, confirmation number, or possibly an error.
   */
  async checkDisbursementStatus (messageKey) {
    Logger.info('Getting disbursement status')
    return tmxApiCall('get', '/cashOut', {
      params: {
        messageKey
      }
    })
  },

  /**
   * Records a record of a referral share.
   * @param {String} name - The name of the referring customer, first and last.
   * @param {String} [email] - The email address of the referring customer.
   * @param {String} [phone] - The phone number of the referring customer.
   * @param {String} [storeNumber] - The 5 digit store number the referring customer is associated with.
   * @param {String} [storeName] - The name of the store the referring customer is associated with.
   * @param {String} source - The identifier of which way the user shared (email, text, share).
   * @param {String} shortCode - The 4 or 5 digit number/character string unique to each referring customer.
   * @returns {Promise<{}>} Empty response.
   */
  async recordShareEvent (name, email, phone, storeNumber, storeName, source, shortCode) {
    Logger.info('Getting disbursement status')
    return tmxApiCall('post', '/referralShare', {
      name,
      email,
      phone,
      storeNumber,
      storeName,
      source,
      shortCode
    })
  }
}
